import React, { useState } from 'react'
import Title from '../../../components/Title/Title';
import SectionHeader from '../../../components/SectionHeader';
import Para from '../../../components/Para';
import QuiteIcon from "../../../assets/images/icons/quote.png";
import Testimonial from '../../../components/Testimonial';

function Summary(props) {

  return (
    <>
 <div className="about-us">

</div>
      
      <div className="container-fluid2 bg2 ">
        <Title options={{ "title": "Our Community | EFH Online ICSE & CBSE Tuition", "description": "Meet the EFH community of students and parents who trust our online Computer Science tuition for ICSE and CBSE learners of Class 9-12.", "image": "", "url": "" }} />

        <div className="container sectionheader ">


          <div className='row'>
            <div className='col-md-12'>
              <div className='card p-3'>
              
       
                              <h2 className="head1">
                                Who they are
                              </h2>
                         
                            
                            <Para className="para textmonial-para">
                              Our Mitrs (friends) are the thousands of students and their
                              parents who have trusted in our teaching style and methods.
                              Several students sought us out when they were struggling with
                              computer science at school. A few months of classes with our
                              experienced teacher resulted in their performance and grades
                              improving considerably. They trust us, and we care for them
                              deeply. We are connected for life!
                            </Para>
                         
                   


               
                   

                

              </div>
            </div>
          </div>


 

        </div>

        <div>
 
      </div>

 
      <Testimonial />
      </div>
 
    </>
  );
};


export default Summary;
